export default {"src":"/_next/static/media/negative-thoughts.colour.f46cdfe2.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};